<template>

    <div>

        <!-- page-heading -->
        <page-heading :show="true" pageTitle="COMPLAT-CALENDAR-HEADLINE"></page-heading>

        <calendar></calendar>

    </div>


</template>


<script>
import calendar from './incl-complatCalendar';

export default {
    components: {
        calendar
    }
}
</script>
